import BaseError from './BaseError'

// アプリケーション内であらかじめ予期されているエラーは ExpectedError として扱う
// ExpectedError でないものは Sentry に送信する
export default class ExpectedError extends BaseError {}
